import { HAS_ADDED_WIDGET_TO_REPORT, HAS_SEEN_CAN_REORDER } from 'constants/hints/reports';
import type { HintMeta } from 'types/hint';

export const HAS_SEEN_SUGGESTED_HOUR = 'has_seen_suggested_hour';
export const HAS_ADDED_TIME_TO_HOUR = 'should_enter_time';
export const HAS_SEEN_UNLINKED_MEMORIES = 'has_seen_unlinked_memories';
export const HAS_LINKED_MEMORY_TO_PROJECT = 'has_linked_memory_to_project';
export const HAS_SEEN_AI_IGNORED_MEMORIES = 'has_seen_ai_ignore_memories';
export const HAS_SEEN_PROJECTS_DATATABLE = 'has_seen_projects_datatable';

/**
 * Trinary property to trigger a hint when the user first manually ignores a memory on the timeline
 * while ignored memories are hidden.
 * 0 - not ignored yet
 * 1 - has ignored memory but not dismissed hint
 * 2 - has seen and dismissed hint
 */
export const HAS_IGNORED_MEMORY = 'has_ignored_memory';

const DEFAULT_DELAY = 2500;
export const onboardingHintsMeta: Partial<HintMeta> = {
  [HAS_SEEN_SUGGESTED_HOUR]: {
    // TIMELY ONBOARDING #8
    /// Context: Suggestion/Draft Shown.
    // Where: Calendar
    // DONE

    name: 'Real-time draft',
    description:
      'AI sorts your tracked memories into time entries for you (when Memory is "on"). Keep working: it will update them automatically!',
    delay: DEFAULT_DELAY,
    hideUntil: [],
  },

  [HAS_LINKED_MEMORY_TO_PROJECT]: {
    // Tooltip #2
    //
    // Context: Calendar View User clicked the brain/memories({count}) -> Timeline shown.
    // Placement: MemorySideBarToolBar - 'add to project' button.
    // DONE
    name: 'Link memories to projects',
    description:
      'Click the project your memories belong to and simplify the next step: logging time.',
    delay: DEFAULT_DELAY,
    hideUntil: [HAS_SEEN_SUGGESTED_HOUR],
  },

  [HAS_ADDED_TIME_TO_HOUR]: {
    // Tooltip #4
    //
    // Context: New Hour Draft Open,  Hour Named, Project Chosen, Time not adjusted yet..
    // DONE
    name: 'Round your time',
    description: 'Choose the cumulative total you want to log for this entry.',
    delay: DEFAULT_DELAY,
    hideUntil: [HAS_SEEN_SUGGESTED_HOUR],
  },

  [HAS_SEEN_UNLINKED_MEMORIES]: {
    // Tooltip #5

    // Context: User clicked + on calendar day:  Hour Editor Open, no memories logged
    // If the hourEditor is open and it has that sidebar, bind it on that.
    // DONE

    name: 'Select unlogged memories',
    description: 'Click any relevant unlogged memories to add them to your entry.',
    delay: DEFAULT_DELAY,
    hideUntil: [HAS_SEEN_SUGGESTED_HOUR],
  },

  [HAS_SEEN_PROJECTS_DATATABLE]: {
    name: 'New projects view',
    description:
      'Sort and filter all projects in one place, select multiple projects for bulk actions, and customize which columns are visible.',
    delay: 500,
  },
};

export const onboardingHints = [
  HAS_SEEN_SUGGESTED_HOUR,
  HAS_ADDED_TIME_TO_HOUR,
  HAS_SEEN_UNLINKED_MEMORIES,
  HAS_LINKED_MEMORY_TO_PROJECT,
  HAS_ADDED_WIDGET_TO_REPORT,
  HAS_SEEN_CAN_REORDER,
  HAS_SEEN_AI_IGNORED_MEMORIES,
  HAS_IGNORED_MEMORY,
  HAS_SEEN_PROJECTS_DATATABLE,
] as const;

export type OnboardingHint = (typeof onboardingHints)[number];
